module.exports = __webpack_public_path__ + "static/img/activity1.a4477e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity1.png
// module id = i0Jq
// module chunks = 1